module.exports = __webpack_public_path__ + "img/bi.ca84e396.svg";